import React from 'react';
import ProgressBarNota from '../ProgressBarNota';
import Typography from '../../Typography';
import ContextTela from '../../../pages/DicasOtimizacao/telaContext';
import { useContext } from '@wordpress/element';
import Card from '../../Card';

export default function CardAnalise({ children, textoButton = false, nota, titulo, subTitulo }) {
  const { desktop } = useContext(ContextTela);
  return (
    <Card
      className={` ${desktop && 'px-[18px] py-6'} divide-y divide-divider-medium`}
      exibir={desktop}
    >
      <div className={`${desktop ? 'w-5/6' : 'w-full'} py-4`}>
        <Typography component="h6" className="mb-4">
          {titulo}
        </Typography>
        <Typography component="body-secundary" className="mb-4">
          {subTitulo}
        </Typography>
        <ProgressBarNota nota={nota} />
      </div>
      <div style={{ height: 'calc(100% - 10.938em)' }}>
        {textoButton && nota > -1 && (
          <Typography component="body-secundary" className="mt-[18px]">
            Ative o botão referente a cada critério que deseja ver no texto.
          </Typography>
        )}
        {children}
      </div>
    </Card>
  );
}
